import hammer from 'hammerjs';

const carousel = (element) => {
	// elements
	const carousel = document.querySelector(element + '-slider');
	const items = carousel.children;
	const dots = document.querySelectorAll(element + '-dot');
	const arrow = document.querySelector(element + '-arrow');

	// check if elemnts exsist
	if (!carousel || !items) {
		return;
	}

	// widtmehs & position & delimeters
	let carouselWidth = 0;
	let itemWidth = 0;
	let currentPosition = 0;
	let itemsLenght = items.length;
	let currentWidth = window.innerWidth;
	let isMobile = currentWidth <= 767;

	const setWidth = () => {
		if (isMobile) {
			for (let item of items) {
				const width = item.offsetWidth;
				const marginLeft = parseInt(window.getComputedStyle(item).getPropertyValue('margin-left'));
				const marginRight = parseInt(window.getComputedStyle(item).getPropertyValue('margin-right'));

				const outerWidth = width + marginLeft + marginRight;

				carouselWidth += outerWidth;
				itemWidth = outerWidth;
			}

			carousel.style.width = carouselWidth + 'px';
		}
	};

	const currentDot = () => {
		if (dots) {
			for (const [index, dot] of dots.entries()) {
				if (index == currentPosition) {
					dot.classList.add('active');
				} else {
					dot.classList.remove('active');
				}
			}
		}

		if (arrow) {
			if (currentPosition == itemsLenght - 1) {
				arrow.classList.add('transformed');
			} else {
				arrow.classList.remove('transformed');
			}
		}
	};

	const goTo = (index) => {
		if (isMobile) {
			currentPosition = index;

			carousel.style.transform = `translateX(-${itemWidth * currentPosition}px)`;

			currentDot();
		}
	};

	const prev = () => {
		if (currentPosition > 0) {
			currentPosition--;

			carousel.style.transform = `translateX(-${itemWidth * currentPosition}px)`;

			currentDot();
		}
	};

	const next = () => {
		if (currentPosition < itemsLenght - 1) {
			currentPosition++;

			carousel.style.transform = `translateX(-${itemWidth * currentPosition}px)`;

			currentDot();
		}
	};

	if (arrow) {
		arrow.addEventListener('click', (e) => {
			e.preventDefault()

			if (currentPosition < itemsLenght -1) {
				goTo(currentPosition + 1);
			} else {
				goTo(0);
			}
		});
	}

	const moveDetect = () => {
		const swipe = new hammer(carousel);

		swipe.on('swipeleft', function(e) {
			if (isMobile) {
				next();
			}
		});

		swipe.on('swiperight', function(e) {
			if (isMobile) {
				prev();
			}
		});
	}

	const dotsNav = () => {
		if (dots) {
			for (const [index, dot] of dots.entries()) {
				dot.addEventListener('click', (e) => {
					goTo(index);
				});
			}
		}
	};

	const run = () => {
		setWidth();
		moveDetect();
		dotsNav();
	};

	const reRun = () => {
		carouselWidth = 0;
		itemWidth = 0;
		currentPosition = 0;

		setWidth();
	};

	const destroy = () => {
		carousel.style.width = 'auto';
		carousel.style.transform = 'translateX(0)';
	};

	run();

	window.onresize = () => {
		currentWidth = window.innerWidth;
		isMobile = currentWidth <= 767;

		(isMobile) ? reRun() : destroy();
	}
}

export default carousel;


// WEBPACK FOOTER //
// ./assets/js/partials/carousel.js